module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('em', [_vm._v("Also by Fay Weldon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE FAT WOMAN’S JOKE")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("DOWN AMONG THE WOMEN")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("FEMALE FRIENDS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("REMEMBER ME")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("LITTLE SISTERS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRAXIS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PUFFBALL")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE PRESIDENT’S CHILD THE LIFE AND LOVES OF A SHE-DEVIL")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE SHRAPNEL ACADEMY")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE HEART OF THE COUNTRY")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE HEARTS AND LIVES OF MEN")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE RULES OF LIFE")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEADER OF THE BAND")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE CLONING OF JOANNA MAY")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("DARCY’S UTOPIA")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("GROWING RICH")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIFE FORCE")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFFLICTION")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("SPLITTING")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORST FEARS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("BIG GIRLS DON’T CRY")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("RHODE ISLAND BLUES")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE BULGARI CONNECTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Children’s Books")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WOLF THE MECHANICAL DOG")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOBODY LIKES ME")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Short-Story Collections")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WATCHING ME, WATCHING YOU")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLARIS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOON OVER MINNEAPOLIS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("WICKED WOMEN")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("A HARD TIME TO BE A FATHER")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOTHING TO WEAR & NOWHERE TO HIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nonfiction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LETTERS TO ALICE")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("REBECCA WEST")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("SACRED COWS")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("GODLESS IN EDEN")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUTO DA FAY")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MANTRAPPED")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0daaa8a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Front1.vue
// module id = 66
// module chunks = 0